module.exports = __webpack_public_path__ + "img/selected2-min.d394da8f.png";